import React from 'react';
import { camelCase } from 'lodash/fp';
import { withTheme, Theme } from 'styled-components';
import { IImageBlock } from '@whitelabel/helpers/types';
import { StyledImagesBlock, StyledImageBox, StyledImage } from './styled';
import getStylesBasedOnTotalImages from './helper';

interface IImagesBlockProps {
  images: IImageBlock[];
  className?: string;
  theme: Theme;
}

const ImagesBlock = ({ images, className, theme }: IImagesBlockProps): JSX.Element => {
  const {
    alignment,
    // @ts-ignore ts-migrate(2339) FIXME: Property 'addMarginTopAfter' does not exist on typ... Remove this comment to see the full error message
    addMarginTopAfter,
    // @ts-ignore ts-migrate(2339) FIXME: Property 'addMarginTopAfterSm' does not exist on t... Remove this comment to see the full error message
    addMarginTopAfterSm,
    // @ts-ignore ts-migrate(2339) FIXME: Property 'addMarginTopAfterMd' does not exist on t... Remove this comment to see the full error message
    addMarginTopAfterMd,
    // @ts-ignore ts-migrate(2339) FIXME: Property 'imageBoxMaxWidth' does not exist on type... Remove this comment to see the full error message
    imageBoxMaxWidth,
    // @ts-ignore ts-migrate(2339) FIXME: Property 'imageBoxMaxWidthSm' does not exist on ty... Remove this comment to see the full error message
    imageBoxMaxWidthSm,
    // @ts-ignore ts-migrate(2339) FIXME: Property 'imageBoxMaxWidthMd' does not exist on ty... Remove this comment to see the full error message
    imageBoxMaxWidthMd,
    // @ts-ignore ts-migrate(2339) FIXME: Property 'imageBoxMaxWidthLg' does not exist on ty... Remove this comment to see the full error message
    imageBoxMaxWidthLg,
    // @ts-ignore ts-migrate(2339) FIXME: Property 'imageMaxWidth' does not exist on type '{... Remove this comment to see the full error message
    imageMaxWidth,
    // @ts-ignore ts-migrate(2339) FIXME: Property 'imageMaxWidthSm' does not exist on type ... Remove this comment to see the full error message
    imageMaxWidthSm,
    // @ts-ignore ts-migrate(2339) FIXME: Property 'imageMaxWidthMd' does not exist on type ... Remove this comment to see the full error message
    imageMaxWidthMd,
  } = getStylesBasedOnTotalImages(images.length, theme);

  return (
    <StyledImagesBlock
      alignment={alignment}
      addMarginTopAfter={addMarginTopAfter}
      addMarginTopAfterSm={addMarginTopAfterSm}
      addMarginTopAfterMd={addMarginTopAfterMd}
      className={className}
    >
      {images.map(({ image, altText }: any) => (
        <StyledImageBox
          imageBoxMaxWidth={imageBoxMaxWidth}
          imageBoxMaxWidthSm={imageBoxMaxWidthSm}
          imageBoxMaxWidthMd={imageBoxMaxWidthMd}
          imageBoxMaxWidthLg={imageBoxMaxWidthLg}
          key={camelCase(altText || image.title)}
        >
          <StyledImage
            imageMaxWidth={imageMaxWidth}
            imageMaxWidthSm={imageMaxWidthSm}
            imageMaxWidthMd={imageMaxWidthMd}
            alt={altText || image.title}
            src={image.file}
          />
        </StyledImageBox>
      ))}
    </StyledImagesBlock>
  );
};

export default withTheme(ImagesBlock);
